import {
  Button as AntButton,
  Card,
  Col,
  DatePicker,
  Icon,
  Input,
  Popconfirm,
  Row,
  Select,
  Typography,
  Upload,
  message,
} from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LoadingComponent from '../../components/common/LoadingComponent';
import {
  changeStatusOfMoU,
  deleteMouForCenter,
  fetchMoUDetailsForCenter,
  removeMouDocument,
  saveMouCategoryCenter,
  saveMouDetailsForCenter,
  uploadMouDocument,
  verifyPan,
  fetchCenterBasicProfile,
  verifyName,
  uploadDocument,
  verifyUpi
} from '../../services/profiling';

import { showValidationError, showError } from '../../utils';
import styled from 'styled-components';
import { ThreeDots } from  'react-loader-spinner'

const VerifyBtnY = styled.button`
width: 90px;
height: 30px;
display: flex;
padding: 8px 12px;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 8px;
border-color: transparent;
background: #4096ff;
color: #FFF;
cursor: pointer;
margin-left: 20px;
`


const VerifyBtnN = styled.div`
width: 90px;
height: 30px;
display: flex;
padding: 8px 12px;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 8px;
border-color: transparent;
background: #f0f0f0;
color: #bfbfbf;
cursor: not-allowed;
margin-left: 20px;
`

const { Text, Title } = Typography;
const { Option } = Select;

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

function sortMouList(moulist) {
  const sortAsc = (a, b) => b.createdAt - a.createdAt;
  moulist.sort(sortAsc);
  return moulist;
}
class NetworkCenterMoUAddScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      addMouModalVisible: false,
      fileList: [],
      fileListPrev: [],
      mouCategory: null,
      mouStatus: null,
      mouStartDate: null,
      mouEndDate: null,
      mouName: null,
      startDateDisabled: false,
      endDateDisabled: false,
      previewVisible: false,
      previewImage: '',
      previewTitle: '',
      documentCategory: null,
      mouLogIds: [],
      documentType: null,
      panNumber: null,
      panName: null,
      panCheck: false,
      panVerified: false, // F
      panNameVerified: true, // T
      panDeclaration: false,
      verifyLoading: false,
      message: 'MoU Documents',// I Have Just Added this for practice
      documentsUploaded: {
        documentType: false,
        mouStatus: false,
        mouStartDate: false,
        mouEndDate: false,
        mouDocuments: false,

      },// I Have Just Added this for practice
      lastpanNumber: '*',
    };

    this.centerId = props.centerId;
  }

  componentDidMount = () => {
    if (this.centerId && this.centerId !== -1) {
      console.log('Mount!');
      this.fetchMou();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const {panNumber} = this.state;
    if(panNumber !== prevState.panNumber) {
       let pattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
       const panVerified = pattern.test(panNumber);
       panNumber && panVerified ? this.setState({panCheck: true, panVerified: false}) : this.setState({panCheck: false, panVerified: false});
    }
  }

  fetchMou = () => {
    return fetchMoUDetailsForCenter(this.props.centerId)
      .then((response) => {
        console.log('Response fetch MoU: ', response);
        const mouList = response.result;
        let reverseList = sortMouList(mouList);
        reverseList = reverseList.reduce((acc, curr) => {
          let keyName = `${curr.type}|${curr.category}`;
          if (curr.fetchedFrom) {
            keyName += `|${curr.fetchedFrom}`;
          }
          if (acc[keyName]) acc[keyName].push(curr);
          else acc[keyName] = [curr];
          return acc;
        }, {});
        reverseList = Object.values(reverseList);
        console.log(reverseList, '[Reverse List!]');
        this.setState({
          fileListPrev: reverseList,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  };

  deleteMou = (mouId) => {
    return deleteMouForCenter(mouId)
      .then((response) => {
        console.log('MoU deleted!');
        message.success('success');
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.fetchMou();
      });
  };

  closeMoUModal = () => {
    console.log('MoU Modal Closed!');
    this.setState({
      mouCategory: 1,
      mouStatus: null,
      mouStartDate: null,
      mouEndDate: null,
      mouName: null,
      fileList: [],
      previewVisible: false,
      previewImage: '',
      previewTitle: '',
      documentCategory: '',
      mouLogIds: [],
    });
  };
  saveMouCategory = () => {
    console.log('database updated');
    const { documentCategory, mouStartDate, documentType } = this.state;
    const { centerId } = this.props;

    const payload = {
      documentCategory,
      mouStartDate,
      documentType,
      centerId,
    };

    return saveMouCategoryCenter(payload)
      .then((response) => {
        console.log('Successfully saved category', response);
        message.success('Saved category');
      })
      .catch((err) => {
        console.log(err);
      });
  };

  saveMouDetails = () => {
    console.log('Mou Details saved!');
    // API to save the MoU details
    const {
      mouCategory,
      mouStatus,
      mouStartDate,
      mouEndDate,
      mouName,
      fileList,
      mouLogIds,
      documentType,
      documentCategory,
      panNumber,
      panName,
    } = this.state;
    const { centerId } = this.props;
    const finalMouIds = mouLogIds.map((m) => {
      return m.mouLogId;
    });

    // if (mouStatus === '1' || mouStatus === '2') {
    //     if (mouEndDate) {
    //         showValidationError({
    //             errorTitle: 'Clear end date for this status!',
    //             errorDesc: 'Agreed and email confirmation or Agreed facilitation but no written confirmation cannot have end dates'
    //         })
    //         return;
    //     } else if (!mouStartDate) {
    //         showValidationError({
    //             errorTitle: 'Start date missing',
    //             errorDesc: 'Agreed and email confirmation or Agreed facilitation but no written confirmation must have start dates'
    //         })
    //         return;
    //     }
    // }

    if (mouStatus === '3') {
      if (mouEndDate || mouStartDate) {
        showValidationError({
          errorTitle: 'Clear start and End dates',
          errorDesc: 'MoU pending status cannot have start or end date',
        });
        return;
      }
    }

    if (mouStatus === '4') {
      if (!mouStartDate || !mouEndDate) {
        showValidationError({
          errorTitle: 'start or end dates missing',
          errorDesc:
            'Agreement signed at both ends should have start and end dates',
        });
        return;
      }
    }

    if (mouCategory === '6') {
      if (!panNumber) {
        showValidationError({
          errorTitle: 'Pan Number missing',
          errorDesc: 'Please provide Pan Number',
        });
        return;
      }
      if (!panName) {
        showValidationError({
          errorTitle: 'Name on Pan Card missing',
          errorDesc: 'Please provide Name on Pan Card',
        });
        return;
      }
      if(!this.state.panVerified) {
        showValidationError({
          errorTitle: 'Pan not verified',
          errorDesc: 'Please verify the pan number'
        });
        return;
      }
      if(!this.state.panNameVerified) {
        showValidationError({
          errorTitle: 'Declaration not found',
          errorDesc: 'Please upload pan declaration'
        });
        return;
      }
    }

    if (!mouStatus) {
      showValidationError({
        errorTitle: 'MoU status missing',
        errorDesc: 'Please provide a MoU Status',
      });
      return;
    }

    if (mouLogIds.length === 0) {
      showValidationError({
        errorTitle: 'MoU Attachment Missing!',
        errorDesc: 'Please attatch atleast on MoU document',
      });
      return;
    }

    const payload = {
      centerId,
      mouCategory,
      mouStatus,
      mouStartDate,
      mouEndDate,
      mouName,
      finalMouIds,
      documentType,
      panNumber,
      panName,
    };

    console.log('Final Payload: ', payload);
    return saveMouDetailsForCenter(payload)
      .then((response) => {
        console.log('Successfully saved MoU', response);
        message.success('Saved MoU');
        // this.saveMouCategory();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.closeMoUModal();
        this.fetchMou();
      });
  };

  mouCategoryChangeHandler = (value) => {
    console.log('Category val: ', value);
    this.setState({
      mouCategory: value,
    });
  };

  moudocumentCategoryHandler = (value) => {
    console.log('document type  val: ', value);
    this.setState({
      documentType: value,
    });
  };

  mouourceHandler = (value) => {
    console.log('document type  val: ', value);
    this.setState({
      mouCategory: value,
    });
  };
  mouCentredocumentCategoryHandler = (value) => {
    console.log('document type  val: ', value);
    this.setState({
      mouCategory: value,
    });
  };

  mouStatusChangeHandler = (status) => {
    console.log('Current Status: ', status);
    this.setState({
      mouStatus: status,
    });
  };

  startDateChangeHandler = (date, dateString) => {
    console.log('Start date', date);
    console.log('Start date string', dateString);
    this.setState({
      mouStartDate: moment(dateString, 'YYYY-MM-DD'),
    });
  };

  disabledDate = (current) => {
    // Can not select days before today and today
    return current && current < moment().startOf('day');
  };

  disabledDateEnd = (current) => {
    return current && current < moment().endOf('day');
  };

  endDateChangeHandler = (date, dateString) => {
    console.log('Start date', date, dateString);

    this.setState({
      mouEndDate: moment(dateString, 'YYYY-MM-DD'),
    });
  };

  handlePreview = (file) => {
    let promise = Promise.resolve();
    if (!file.url && !file.preview) {
      promise = getBase64(file.originFileObj);
    }
    return promise.then((preview) => {
      console.log(file, 'handlePreview');
      file.preview = preview;
      this.setState({
        previewImage: file.url || file.preview,
        previewVisible: true,
        previewTitle:
          file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
      });
    });
  };

  handleChange = ({ fileList }) => {
    console.log(fileList, 'on change');
    this.setState({ fileList });
  };

  handleRemove = (response) => {
    const prevMouLogIds = this.state.mouLogIds;
    let finalMouIds;
    console.log(response, 'On Remove');
    const deleteObj = prevMouLogIds.filter((m) => m.docUid === response.uid);
    console.log(deleteObj, '[Deleting this]');
    const deleteMoUId = deleteObj[0].mouLogId;
    return removeMouDocument(deleteMoUId)
      .then(() => {
        finalMouIds = prevMouLogIds.filter((m) => !(m.docUid === response.uid));
        this.setState({
          mouLogIds: finalMouIds,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleUpload = (response) => {
    const { centerId } = this.props;
    const { documentCategory, mouLogIds } = this.state;
    let mouLogId,
      docUid = response.file.uid;
    console.log(centerId, documentCategory, 'HandleUpload');
    console.log(response.file.uid, 'HandleUpload Response UID Check');
    return uploadMouDocument(
      centerId,
      documentCategory,
      response.file,
      response.onProgress
    )
      .then((resInfo) => {
        console.log(resInfo, 'uploadMouDocument response');
        mouLogId = resInfo.result.mouLogId;
        this.setState({
          mouLogIds: [...mouLogIds, { mouLogId, docUid }],
        });
        response.onSuccess(response, response.file);
      })
      .catch((err) => {
        response.onError(err);
      });
  };

  handleOk = (mouId) => {
    console.log('Delete mouId', mouId);
    this.deleteMou(mouId);
  };

  handleCancel = () => {
    console.log('Cancel');
  };

  handleEditStatusChange = (mouId, status) => {
    console.log('Status Changing!');
    changeStatusOfMoU(mouId, status)
      .then(() => {
        message.success('Success');
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.fetchMou();
      });
  };

  handlePanUpload = (response) => {
    const { doctorId, centerId} = this.props;
    console.log(doctorId, centerId, 'HandleUPload');
    uploadDocument(doctorId, centerId, 'pan_declaration', response.file, response.onProgress)
        .then((response) => {
          this.setState({
            panNameVerified: true
          })
          message.success('pan declaration uploaded successfully');
          response.onSuccess(response, response.file);
        })
        .catch((err) => {
            response.onError(err);
        });
    };

  handlePanVerification = async () => {
    try {
      const {panNumber, lastpanNumber} = this.state;
      if(lastpanNumber === panNumber) {
        this.setState({panCheck: false});
        return message.error('Please update pan number');
      }
      this.setState({verifyLoading: true, lastpanNumber: panNumber});
      const panData = await verifyPan(panNumber);
      console.log(panData);
      if(panData.data && panData.data.valid) {
        this.setState({panVerified: true, panName: panData.data.registered_name});
        const centerDetails = await fetchCenterBasicProfile(this.props.centerId);
        const bankAccount = centerDetails.fulfilment && centerDetails.fulfilment.accountNumber ? centerDetails.fulfilment.accountNumber : null;
        const ifsc = centerDetails.fulfilment && centerDetails.fulfilment.ifscCode ? centerDetails.fulfilment.ifscCode : null;
        const upiId = centerDetails.fulfilment.upiAddress;
        if(bankAccount && ifsc) {
          const configData = {
            bankAccount,
            ifsc,
            type: 'BANK'
          }
          this.handlePanNamecheck(configData);
        } else if(upiId) {
          const configData = {
            upiId,
            type: 'UPI',
            panData
          }
          this.handlePanNamecheck(configData);
        } else {
          this.setState({panVerified: false, verifyLoading: false});
          return message.error('No bank or UPI details found');
        }
      }
      this.setState({verifyLoading: false});
    }
    catch(err) {
      console.log(err);
      this.setState({verifyLoading: false});
    }
  }

  handlePanNamecheck = async ({bankAccount, ifsc, type, upiId, panData}) => {
    try {
      if(type === 'BANK') {
        const {panNumber} = this.state;
        if(!bankAccount || !ifsc) {
          this.setState({panVerified: false});
          return message.error('No bank details found');
        }
        console.log(bankAccount, ifsc);
        const nameVerified = await verifyName(panNumber, bankAccount, ifsc);
        console.log(nameVerified);
        if(nameVerified.message === 'success') {
          this.setState({panNameVerified: true});
          message.success('Pan verified');
        } else {
          message.success('Pan verified');
          message.error(nameVerified.errorMessage);
          message.error('Please upload pan declaration');
          this.setState({panNameVerified: false});
        }
      } else if(type === 'UPI') {
        if(!upiId) {
          this.setState({panVerified: false});
          return message.error('No UPI details found');
        }
        console.log(upiId);
        this.setState({panNameVerified: true});
        message.success('Pan verified');
        // const upiDetails = await verifyUpi(upiId);
        // console.log(upiDetails);
        // if((upiDetails.errsubCode && upiDetails.errsubCode !== '200') || upiDetails.errsubCode === '200') {
        //   message.success('Pan verified');
        //   message.error(upiDetails.errorMessage || 'Something went wrong');
        //   return message.error('Please verify UPI details and try again');
        // }
        // if(upiDetails.data && upiDetails.data.accountExists === 'YES' && upiDetails.data.nameAtBank.toUpperCase() === panData.data.registered_name.toUpperCase()) {
        //   this.setState({panNameVerified: true});
        //   message.success('Pan verified');
        // } else {
        //   message.success('Pan verified');
        //   message.error('Name mismatch between PAN and UPI records');
        //   message.error('Please upload pan declaration');
        //   this.setState({panNameVerified: false});
        // }
      }
    }
    catch(err) {
      console.log(err);
    }
  }
  //Just trying to add a new function to handle document upload
  handleDocumentUpload = () => {
    console.log('Document uploaded');

  }

  render() {
    const {
      addMouModalVisible,
      fileList,
      mouCategory,
      mouStatus,
      mouName,
      fileListPrev,
      mouLogIds,
      documentType,
      documentCategory,
      panNumber,
      panName,
    } = this.state;
    console.log(fileList, '[FILE LIST]');
    console.log(mouLogIds, '[MoU Logs]');

    return (
      <>
        {this.state.loading ? (
          <LoadingComponent />
        ) : (
          <>
            <Row>
              <Col span={12}>
                {fileListPrev.length > 0 &&
                  fileListPrev.map((mous, index) => {
                    const headerText = `${mous[0].type} | ${mous[0].category} ${
                      mous[0].fetchedFrom === 'parent' ? '| Parent Center' : ''
                    }`;
                    return (
                      <div key={`${headerText}_${index}`}>
                        <div
                          style={{
                            border: '1px solid #D3D3D3',
                            width: '70%',
                            display: 'flex',
                            paddingTop: '14px',
                          }}
                        >
                          <p style={{ marginLeft: '24px' }}>
                            <strong>{headerText}</strong>
                          </p>
                        </div>
                        <Card
                          // key={index}
                          title={mous[0].name}
                          style={{
                            width: '70%',
                            marginBottom: '10px',
                            paddingTop: '0px',
                          }}
                        >
                          {mous.map((mou, index) => {
                            const mouCardItemStyle =
                              index != 0 ? { marginTop: '24px' } : {};
                            return (
                              <div key={`${mou.id}_${index}`}>
                                <div style={mouCardItemStyle}>
                                  <p>
                                    <strong>Status:</strong> {mou.status}
                                  </p>
                                  <p>
                                    <strong>Start Date:</strong> {mou.startDate}
                                  </p>
                                  <p>
                                    <strong>End Date:</strong> {mou.endDate}
                                  </p>
                                  <p>
                                    <strong>Agreement Expired:</strong>{' '}
                                    {mou.expired == 'true' ? (
                                      <span>Yes</span>
                                    ) : (
                                      <span>No</span>
                                    )}
                                  </p>
                                  {mou.mouFiles &&
                                    mou.category === 'Pan Card' && (
                                      <>
                                        <p>
                                          <strong>Pan Number:</strong>{' '}
                                          <span>
                                            {mou.mouFiles.length > 0 &&
                                            mou.mouFiles[0].panNumber
                                              ? mou.mouFiles[0].panNumber
                                              : 'Not Available'}
                                          </span>
                                        </p>
                                        <p>
                                          <strong>Name On Pan Card:</strong>{' '}
                                          <span>
                                            {mou.mouFiles.length > 0 &&
                                            mou.mouFiles[0].panName
                                              ? mou.mouFiles[0].panName
                                              : 'Not Available'}
                                          </span>
                                        </p>
                                      </>
                                    )}
                                  <div style={{ marginBottom: '5px' }}>
                                    <strong>Documents:</strong>{' '}
                                    {mou.mouFiles.map((file, idx) => {
                                      return (
                                        <div
                                          key={`${file.title}_${idx}`}
                                          style={{ marginBottom: '4px' }}
                                        >
                                          <Icon
                                            style={{ marginRight: '4px' }}
                                            type="file"
                                          />
                                          <a href={file.link}>{file.title}</a>
                                        </div>
                                      );
                                    })}
                                  </div>
                                  <Popconfirm
                                    title="Are you sure to delete this MoU?"
                                    onConfirm={() => this.handleOk(mou.mouId)}
                                    onCancel={this.handleCancel}
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <div style={{ marginTop: '14px' }}>
                                      <a
                                        href="#"
                                        style={{
                                          color: 'red',
                                          marginTop: '10px',
                                          textDecoration: 'underline',
                                        }}
                                      >
                                        Delete
                                      </a>
                                    </div>
                                  </Popconfirm>
                                </div>
                                {mous.length - 1 !== index ? (
                                  <div
                                    style={{
                                      marginTop: '5px',
                                      borderBottom: '1px solid #E8E8E8',
                                      marginRight: '-24px',
                                      marginLeft: '-24px',
                                    }}
                                  />
                                ) : (
                                  ''
                                )}
                              </div>
                            );
                          })}
                        </Card>
                      </div>
                    );
                  })}
                {fileListPrev.length === 0 && <div>No MoU Found!</div>}
              </Col>
              <Col span={12}>
                <Card
                  title="Upload Documents"
                  style={{ width: '100%', marginBottom: '10px' }}
                >
                  <Row>
                    <Col>
                      <div
                        style={{
                          marginBottom: '20px',
                          display: 'flex',
                          flexDirection: 'horizontal',
                        }}
                      >
                        <span style={{ width: '15%' }}>Document type:</span>
                        <Select
                          value={documentType}
                          onChange={this.moudocumentCategoryHandler}
                          style={{ width: '40%' }}
                        >
                          <Option value="center-documents">
                            Center documents
                          </Option>
                          <Option value="agreements">Agreement document</Option>
                          <Option value="Hospital Registration">
                            Hospital Registration
                          </Option>
                          <Option value="Lab Registration">
                            Lab Registration
                          </Option>
                        </Select>
                      </div>
                      {documentType === 'center-documents' && (
                        <div
                          style={{
                            marginBottom: '20px',
                            display: 'flex',
                            flexDirection: 'horizontal',
                          }}
                        >

                          <Select
                            value={mouCategory}
                            onChange={this.mouCentredocumentCategoryHandler}
                            style={{ width: '40%' }}
                          >
                            <Option value="1">Agreement - MOU</Option>
                            <Option value="2">Agreement - Whatsapp</Option>
                            <Option value="3">Agreement - Mail</Option>
                            <Option value="4">
                              Payment Details - Cancelled Cheque
                            </Option>
                            <Option value="5">Payment Details - UPI</Option>
                            {/* <Option value="6">Pan Card</Option> */}
                            <Option value="7">Certificate - TDS</Option>
                            <Option value="8">Certificate - NABH</Option>
                            <Option value="9">Certificate - NABL</Option>
                            <Option value="10">Rohini Certificate</Option>
                            <Option value="13">DOS list</Option>
                            <Option value="15">LTDC (Lower Tax Deduction Certificate)</Option>
                            <Option value="16">Centre Registration Certificate / Biomedical Waste Management Certificate</Option>
                            <Option value="17">MBBS / MD Certificates</Option>
                            <Option value="18">PCPNDT Certificate</Option>
                            <Option value="19">Pathologist / Cardiologist Certifications</Option>
                            <Option value="20">Internal Audit Reports</Option>
                            <Option value="21">Declaration Against Fraud</Option>
                            <Option value="22">Machine Calibration Compliance Certificate</Option>
                            <Option value="23">Photographs, Videos, and Google Coordinates of the Center</Option>
                            <Option value="24">Beneficiary Declaration</Option>
                            <Option value="25">Any Other Document</Option>
                          </Select>
                        </div>
                      )}
                      {mouCategory === '6' &&
                        documentType === 'center-documents' && (
                          <>
                            <div
                              style={{
                                marginBottom: '20px',
                                display: 'flex',
                                flexDirection: 'horizontal',
                              }}
                            >
                              <span style={{ width: '15%' }}>Pan Number:</span>
                              <Input
                                value={panNumber}
                                onChange={(e) => {
                                  this.setState({
                                    panNumber: e.target.value,
                                  });
                                }}
                                style={{ width: '40%' }}
                              />
                              {
                                !this.state.panVerified ? (this.state.panCheck && !this.state.verifyLoading ? (<VerifyBtnY onClick={this.handlePanVerification}>Verify</VerifyBtnY>) : (<VerifyBtnN>Verify</VerifyBtnN>)) : (<VerifyBtnN>Verify</VerifyBtnN>)
                              }
                              {
                                this.state.verifyLoading && (<ThreeDots
                                                    height="40"
                                                    width="40"
                                                    radius="9"
                                                    color="#4096ff"
                                                    ariaLabel="three-dots-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClassName=""
                                                    visible={true}
                                                  />)
                              }
                            </div>
                            <div
                              style={{
                                marginBottom: '20px',
                                display: 'flex',
                                flexDirection: 'horizontal',
                              }}
                            >
                              <span style={{ width: '15%' }}>
                                Name on Pan Card:
                              </span>
                              <Input
                                value={panName}
                                onChange={(e) => {
                                  this.setState({
                                    panName: e.target.value,
                                  });
                                }}
                                style={{ width: '40%' }}
                              />
                            </div>
                            {
                            this.state.panVerified && !this.state.panNameVerified && (
                              <div style={{marginBottom: '20px'}}>
                                <span style={{ width: '15%' }}>Pan Declaration:</span>
                                <Upload
                                  accept="image/*,application/pdf"
                                  customRequest={this.handlePanUpload}
                                >
                                  <AntButton>
                                    <Icon type="upload" /> Upload
                                  </AntButton>
                                </Upload>
                               </div>
                            )
                          }
                          </>
                        )}
                      {documentType === 'agreements' && (
                        <div
                          style={{
                            marginBottom: '20px',
                            display: 'flex',
                            flexDirection: 'horizontal',
                          }}
                        >
                          <span style={{ width: '15%' }}>Category</span>
                          <Select
                            value={mouCategory}
                            onChange={this.mouourceHandler}
                            style={{ width: '40%' }}
                          >
                            <Option value="11">
                              MSA (Master service agreement)
                            </Option>
                            <Option value="12">
                              {' '}
                              SOW (Statement of Work){' '}
                            </Option>
                          </Select>
                        </div>
                      )}

                      <div
                        style={{
                          marginBottom: '20px',
                          display: 'flex',
                          flexDirection: 'horizontal',
                        }}
                      >
                        <span style={{ width: '15%' }}>Status:</span>
                        <Select
                          value={mouStatus}
                          style={{ width: '40%' }}
                          onChange={this.mouStatusChangeHandler}
                        >
                          <Option value="1">
                            Agreed and email confirmation
                          </Option>
                          <Option value="2">
                            Agreed facilitation but no written confirmation
                          </Option>
                          <Option value="3">MoU pending</Option>
                          <Option value="4">
                            Agreement signed at both ends
                          </Option>
                          <Option value="5">Agreement Expired</Option>
                        </Select>
                      </div>
                      <div
                        style={{
                          marginBottom: '20px',
                          display: 'flex',
                          flexDirection: 'horizontal',
                        }}
                      >
                        <span style={{ width: '15%' }}>Start Date:</span>
                        <DatePicker
                          value={this.state.mouStartDate}
                          allowClear={false}
                          onChange={this.startDateChangeHandler}
                        />
                      </div>
                      <div
                        style={{
                          marginBottom: '20px',
                          display: 'flex',
                          flexDirection: 'horizontal',
                        }}
                      >
                        <span style={{ width: '15%' }}>End Date:</span>
                        <DatePicker
                          value={this.state.mouEndDate}
                          allowClear={false}
                          onChange={this.endDateChangeHandler}
                        />
                      </div>
                      <div
                        style={{
                          marginBottom: '20px',
                          display: 'flex',
                          flexDirection: 'horizontal',
                        }}
                      >
                        <span style={{ width: '15%' }}>{this.state.message}</span>
                        <Upload
                            accept="image/*,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          fileList={fileList}
                          onPreview={this.handlePreview}
                          onChange={this.handleChange}
                          onRemove={this.handleRemove}
                          beforeUpload={this.beforeUpload}
                          customRequest={this.handleUpload}
                        >
                          <AntButton>
                            <Icon type="upload" /> Upload
                          </AntButton>
                        </Upload>
                      </div>
                      <div
                        style={{
                          marginBottom: '20px',
                          display: 'flex',
                          flexDirection: 'horizontal',
                          float: 'right',
                        }}
                      >
                        <AntButton
                          onClick={this.closeMoUModal}
                          style={{ marginRight: '20px' }}
                        >
                          Clear
                        </AntButton>
                        <AntButton onClick={this.saveMouDetails} type="primary">
                          Save
                        </AntButton>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});

export default withRouter(connect(mapStateToProps)(NetworkCenterMoUAddScreen));

